import { CrmTaskStatus } from '@plato/data/prisma';
import { Checkbox } from '@plato/ui-legacy/components/ui/checkbox';
import SmallSpinner from '@plato/ui-legacy/components/ui/small-spinner';
import type { CrmTaskDTO } from '../../../../server/dto/crm-task-dto.ts';
import type { TaskCompletedSource } from '../../../analytics/types/analytics-events.ts';

import { useToggleTask } from '../../hooks/use-toggle-task.tsx';

export type TaskUpdateCheckboxProps = {
    task: CrmTaskDTO;
    source: TaskCompletedSource;
};

export function TaskUpdateCheckbox({ task, source }: TaskUpdateCheckboxProps) {
    const { isPending, setTaskComplete } = useToggleTask(source);

    if (isPending) {
        return <SmallSpinner />;
    }

    return (
        <div
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <Checkbox
                checked={task.status === CrmTaskStatus.COMPLETED}
                onCheckedChange={(value) => {
                    setTaskComplete(task.taskId, value === true);
                }}
                className="rounded-lg"
            />
        </div>
    );
}
